<header
  class="bg-white dark:bg-gray-800 text-gray-900 dark:text-white py-3 px-4 shadow-md flex justify-between items-center relative z-40"
>
  <div class="flex items-center">
    <a routerLink="/dashboard" class="flex items-center space-x-2">
      <img src="om_logo_full_h.svg" alt="OrganizeMed Logo" class="h-8 w-auto" data-cy="page-header-img-logo" />
      <span class="text-2xl font-bold text-gray-600 dark:text-gray-200">CaseVUE</span>
      <span> for </span>
      <span class="text-xl text-sky-600 font-semibold">{{ orgName() }}</span>
    </a>
  </div>

  <!-- Universal Search Input -->
  <div class="relative flex-grow mx-4 max-w-lg">
    <app-search-filter
      [searchTerm]="searchTerm()"
      (searchChanged)="onSearchChange($event)"
      (searchFocused)="onSearchFocus()"
      (searchBlurred)="onSearchBlur()"
      data-cy="page-home-input-search"
    >
    </app-search-filter>

    <!-- Search Results Dropdown -->
    @if (showSearchResults() && searchResults().length > 0) {
    <div
      class="absolute top-full left-0 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg mt-1 max-h-60 overflow-y-auto"
    >
      @for (result of searchResults(); track result.id) {
      <a
        (click)="onResultClick(result.id)"
        class="px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer flex items-center space-x-2 flex-row"
        [attr.data-cy]="'page-header-link-searchResult-' + result.id"
      >
        <span class="font-medium">{{ result.accountNumber }}</span>
        <span>{{ result.accountNumber ? '-' : '' }}</span>
        <span>{{ result.firstName | uppercase }}</span>
        <span class="flex flex-grow">{{ result.lastName | uppercase }}</span>
        <span>({{ result.caseType || 'N/A' | uppercase }}</span>
        <span>- {{ result.caseCategory || 'N/A' | uppercase }})</span>
      </a>
      }
    </div>
    } @if (showSearchResults() && searchResults().length === 0 && searchTerm().length > 0) {
    <div
      class="absolute top-full left-0 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-lg mt-1 px-4 py-2 text-sm text-gray-500 dark:text-gray-300"
    >
      No results found.
    </div>
    }
  </div>

  <div class="flex items-center space-x-4">
    @if (currentUser(); as user) {
    <span class="text-md text-sky-600 font-semibold mr-4">{{ firmName() }}</span>
    <a
      routerLink="/tasks"
      class="flex items-center space-x-2 focus:outline-none cursor-pointer transition-opacity hover:opacity-80 text-gray-900 dark:text-white"
      title="Tasks"
      data-cy="page-header-button-tasks"
    >
      <span class="material-symbols-outlined text-2xl">assignment</span>
    </a>
    <div class="relative">
      <button
        (click)="toggleDropdown()"
        class="flex items-center space-x-2 focus:outline-none cursor-pointer transition-opacity hover:opacity-80"
        aria-haspopup="true"
        [attr.aria-expanded]="isDropdownOpen()"
        data-cy="page-userMenu-button-toggle"
      >
        <span class="material-symbols-outlined text-base">account_circle</span>
        <span class="hidden md:block text-lg text-gray-900 dark:text-white">{{ user.displayName }}</span>
        <span class="material-symbols-outlined text-base">keyboard_arrow_down</span>
      </button>

      @if (isDropdownOpen()) {
      <div
        class="absolute right-0 mt-2 w-56 bg-white dark:bg-gray-800 rounded-md shadow-lg py-1 z-50"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="user-menu-button"
      >
        <div class="px-4 py-3">
          <p class="text-sm font-semibold text-gray-900 dark:text-white">{{ user.displayName }}</p>
          <p class="text-sm text-gray-500 dark:text-gray-300 truncate">{{ user.email }}</p>
        </div>
        <div class="px-4 py-3">
          <app-theme-toggle data-cy="page-userMenu-toggle-theme"></app-theme-toggle>
        </div>
        <div class="border-t border-gray-200 dark:border-gray-700"></div>
        <button
          (click)="openHelpDesk()"
          class="w-full text-left flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer"
          role="menuitem"
          data-cy="page-userMenu-button-helpDesk"
        >
          <span class="material-symbols-outlined text-base">help_outline</span>
          Help Desk
        </button>
        <button
          (click)="logout()"
          class="w-full text-left flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer"
          role="menuitem"
          data-cy="page-userMenu-button-logout"
        >
          <span class="material-symbols-outlined text-base">logout</span>
          Logout
        </button>
      </div>
      }
    </div>
    }
  </div>
</header>
